import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import styled from 'styled-components';

import { MetaPages } from '../../enums/pages';
import MarkdownLink from '../../components/atoms/markdown-link/markdown-link';
import SectionContainer from '../../components/atoms/section-container/section-container';
import { getPrivacyPolicyContent } from '../../services/privacy-policy';
import { PrivacyPolicyType } from '../../types/content';
import TabTitle from '../../components/atoms/tab-title/tab-title';

const Container = styled.div`
  font-family: MuseoSans-100;
  font-size: 14px;

  a:hover {
    color: #0081c6;
  }

  strong {
    font-family: MuseoSans-300;
  }

  @media screen and (max-width: 640px) {
    font-size: 16px;
  }
`;

type IndexProps = {
  privacyPolicyContent: PrivacyPolicyType[];
};

export function Index(props: IndexProps) {
  const { privacyPolicyContent } = props;

  const privacyPolicy = privacyPolicyContent.map((privacyPolicyItem) => {
    return (
      <div className="flex flex-col mb-10" key={privacyPolicyItem.policyHeader}>
        <h5 className="font-MuseoSans500 mb-3 text-[19px] sm:text-[17px] font-bold">
          {privacyPolicyItem.policyHeader}
        </h5>
        <Container>
          <ReactMarkdown
            components={{ a: MarkdownLink }}
            rehypePlugins={[rehypeRaw]}
          >
            {privacyPolicyItem.policyContent}
          </ReactMarkdown>
        </Container>
      </div>
    );
  });

  return (
    <>
      <TabTitle page={MetaPages.PRIVACY_POLICY} />
      <div className="bg-ghostWhite">
        <SectionContainer className="-translate-y-12 sm:translate-y-0">
          <div className="my-14">
            <p
              className={`text-2header4 text-center font-ChronicleDisplayRegular mt-4`}
            >
              Privacy Policy
            </p>
          </div>
          {privacyPolicy}
        </SectionContainer>
      </div>
    </>
  );
}

export async function getStaticProps() {
  const privacyPolicyContent = await getPrivacyPolicyContent();

  return {
    props: {
      privacyPolicyContent
    }
  };
}

export default Index;
